import React from 'react';
import { initSentry } from './config/sentry';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import DeepLinkApp from './deeplink/DeepLinkApp';
import { isDeepLinkHostname } from './deeplink/storeConfig';
import ErrorBoundary from './components/common/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { runWhenConsented } from './utils/consentAwareLoader';
import './styles/scss/main.scss';

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const RootApp = isDeepLinkHostname() ? DeepLinkApp : App;

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <RootApp />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Only collect web vitals when the user has granted analytics consent.
// Pass a real sendToAnalytics handler here once an analytics tool is integrated.
runWhenConsented('analytics', () => {
  reportWebVitals();
});
